var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderAi = function SvgPlaceholderAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.9 6.85a.95.95 0 0 1 .95-.95H13c.807-.584 1.144-1.02 1.628-1.9H4.85A2.85 2.85 0 0 0 2 6.85v13.3A2.85 2.85 0 0 0 4.85 23h13.3A2.85 2.85 0 0 0 21 20.15V7.8c-1.067.61-1.492 1.025-1.9 1.9v4.357l-3.128-3.129a.95.95 0 0 0-1.344 0L4.517 21.04a.95.95 0 0 1-.617-.89zm15.2 9.893-3.8-3.8L7.143 21.1H18.15a.95.95 0 0 0 .95-.95z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.7 10.175a.475.475 0 1 1 .95 0 .475.475 0 0 1-.95 0M8.175 7.8a2.375 2.375 0 1 0 0 4.75 2.375 2.375 0 0 0 0-4.75",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 1c.392 2.966 1.625 4.303 5 5.5-2.892.324-4.1 2.162-5 5.5-.698-3.562-1.82-4.735-5-5.5 3.034-.821 4.113-2.044 5-5.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M17 1c.392 2.966 1.625 4.303 5 5.5-2.892.324-4.1 2.162-5 5.5-.698-3.562-1.82-4.735-5-5.5 3.034-.821 4.113-2.044 5-5.5Z"
  })));
};
export default SvgPlaceholderAi;